
import {FBRowOptions} from "./FBRow.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {StoreAutoIncrement, StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {EventManager} from "shared/core/Events/EventManager";
import {LoadExtensionOptions} from "FormBuilder/Events/LoadExtensionOptions";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";





export class MultipleStepItem extends StoreBase{
    @StoreAutoIncrement('MultipleStepItem')
    public Id:number;
    public Title:string;
    @StoreDataType(Number)
    public FieldIds:number[];
    @StoreDataType(Object)
    public Icon:IconOrImage;



    protected LoadDefaultValues() {
        this.Id=0;
        this.Title='';
        this.FieldIds=[];
        this.Icon={ImageType:'none',Ref:null};

    }

}

export class MultipleStepOptions extends StoreBase{
    public NextButtonText:string;
    public PreviousButtonText:string;
    public SubmitButtonText:string;
    @StoreDataType(MultipleStepItem)
    public Steps:MultipleStepItem[];


    protected LoadDefaultValues() {
        this.NextButtonText='Next';
        this.PreviousButtonText='Previous';
        this.SubmitButtonText='Add to cart';
        this.Steps=[];
    }
}



export class FormBuilderOptions extends StoreBase{
    @StoreDataType(FBRowOptions)
    public Rows:FBRowOptions[];
    public Extensions:ExtensionBase[];
    @StoreDataType(String)
    public DynamicFieldTypes:string[];
    public Version=0;
    public Styles:string;
    public MapsApiKey:string;
    @StoreDataType(Object)
    public Icons:{Name:string,icon:any}[];
    @StoreDataType(MultipleStepOptions)
    public MultipleSteps:MultipleStepOptions;
    public OptionsAmountLabel:string;
    public FinalTotalLabel:string;


    protected LoadDefaultValues() {
        this.Rows=[];
        this.DynamicFieldTypes=[];
        this.Version=0;
        this.Styles='';
        this.Extensions=[];
        this.Icons=[];
        this.MapsApiKey='';
        this.MultipleSteps=null;

        this.OptionsAmountLabel=RNTranslate('Options amount');
        this.FinalTotalLabel=RNTranslate('Final Total');
    }


    protected GetValueFromLoader(property:any, value: any): any {
        if(property=='Extensions')
            return value;
        return null;
    }
}




export  abstract class ExtensionBase extends StoreBase{
    Id:string;
    protected abstract LoadDefaultValues();
}

